export const WISH = 'wish';
export const CLOTH = 'cloth';
